import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';

import CoupleSelectTabPanel from './coupleSelectTabPanel';
import PersonGroupTabs from '../personGroupTabs';
import personGroups from '../personGroups';

const CoupleSelectTabs = ({ isLoading, onSelect, partnerRequired, people, treeId }) => {
  const [selectedPartnerByGroup, setSelectedPartnerByGroup] = useState({});
  const [selectedPersonByGroup, setSelectedPersonByGroup] = useState({});

  const displayedPersonGroups = useMemo(
    () => (treeId ? ['all', 'in-book'] : ['in-book']).map(id => personGroups[id]),
    [treeId],
  );
  const [selectedPersonGroup, setSelectedPersonGroup] = useState(displayedPersonGroups[0]);

  const handlePartnerSelect = useCallback(
    ({ person: partner }) => {
      const { id } = selectedPersonGroup;
      setSelectedPartnerByGroup(currentSelectedPartnerByGroup => ({
        ...currentSelectedPartnerByGroup,
        [id]: partner,
      }));
      onSelect({ partner, person: selectedPersonByGroup[id] });
    },
    [onSelect, selectedPersonByGroup, selectedPersonGroup],
  );

  const handlePersonGroupChange = useCallback(
    newSelectedPersonGroup => {
      const { id } = newSelectedPersonGroup;
      setSelectedPersonGroup(newSelectedPersonGroup);
      onSelect({ partner: selectedPartnerByGroup[id], person: selectedPersonByGroup[id] });
    },
    [onSelect, selectedPartnerByGroup, selectedPersonByGroup],
  );

  const handleSelect = useCallback(
    ({ person }) => {
      const { id } = selectedPersonGroup;
      setSelectedPersonByGroup(currentSelectedPersonByGroup => ({
        ...currentSelectedPersonByGroup,
        [id]: person,
      }));
      onSelect({ partner: selectedPartnerByGroup[id], person });
    },
    [onSelect, selectedPartnerByGroup, selectedPersonGroup],
  );

  return (
    <PersonGroupTabs
      isLoading={isLoading}
      onChange={handlePersonGroupChange}
      panel={
        <CoupleSelectTabPanel
          onPartnerSelect={handlePartnerSelect}
          onSelect={handleSelect}
          partnerRequired={partnerRequired}
          selectedPartnerByGroup={selectedPartnerByGroup}
          selectedPersonByGroup={selectedPersonByGroup}
        />
      }
      people={people}
      personGroups={displayedPersonGroups}
      selectedPersonGroup={selectedPersonGroup}
      treeId={treeId}
      includeCitations={false}
    />
  );
};

CoupleSelectTabs.defaultProps = {
  isLoading: false,
  partnerRequired: false,
  people: [],
};

CoupleSelectTabs.propTypes = {
  isLoading: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  partnerRequired: PropTypes.bool,
  people: PropTypes.arrayOf(PropTypes.object),
  treeId: PropTypes.string,
};

export default CoupleSelectTabs;
